import { useEffect } from 'react';
import { flushSnap, resolveSnapOffset } from './snapSession';

// Adaptateur React du moteur, pour l'aperçu de drag.
//
// Le calcul a lieu pendant le rendu (l'aperçu doit être posé à la position
// accrochée dans la MÊME frame, sinon le trait de guide et la box se
// désynchronisent d'une frame). Les effets de bord — publication des guides et
// impulsion haptique — sont repoussés dans un effet, après commit.
export const useDragSnapping = ({ active, offset }) => {
  const snappedOffset = active ? resolveSnapOffset(offset) : offset;

  useEffect(() => {
    if (active) flushSnap();
  });

  return snappedOffset;
};
